import type {DSConfig} from '@wix/document-services-types'
import _ from 'lodash'

export const isHeadless = (dsConfig: DSConfig) =>
    _.get(dsConfig, ['origin']) === 'DMMigrator' || _.get(dsConfig, ['origin']) === 'DMMigratorX'
